import React from 'react'
import { Route, RouteProps } from 'react-router'
import Fallback from 'components/Fallback'

const Drawer = React.lazy(() => import('components/Drawer'))

const CustomRoute: React.FC<RouteProps> = ({ ...rest }) => {
  return (
    <React.Suspense fallback={<Fallback />}>
      <Drawer>
        <Route {...rest} />
      </Drawer>
    </React.Suspense>
  )
}

export default CustomRoute
